// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host-context(.aulani) {
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
  /* For Mobile devices */
  /* For Desktop */
  --primary-dark: #867F77;
  --wdpr-single-select-icon-top: 10px;
  --wdpr-single-select-icon-color: #BBB5B0;
  --wdpr-single-select-custom-option-item-height: 24px;
  --secondary-hover-theme: #B14308;
  --primary-dark-theme: #D04901;
  --secondary-hover: #B14308;
  --wdpr-select-all-button-background-color-hover: #B14308;
  --wdpr-select-item-color-hover: #B14308;
  --wdpr-single-select-active-color: #867F77;
  --wdpr-single-select-label-line-height: 0;
  --wdpr-single-select-border-width: 0 0 2px 0;
}
:host-context(.aulani) * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host-context(.aulani) *:before, :host-context(.aulani) *:after {
  box-sizing: border-box;
}
:host-context(.aulani) *:focus {
  outline: 1px dotted #000;
}
:host-context(.aulani) html,
:host-context(.aulani) body {
  margin: 0;
  min-height: 100vh;
}
:host-context(.aulani) body {
  width: 100%;
}
:host-context(.aulani) img {
  width: 100%;
}
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5 {
  margin: 0;
}
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5,
:host-context(.aulani) h6,
:host-context(.aulani) span,
:host-context(.aulani) a,
:host-context(.aulani) li,
:host-context(.aulani) p,
:host-context(.aulani) input,
:host-context(.aulani) textarea {
  font-family: inherit;
}
:host-context(.aulani) .clearfix, :host-context(.wdw):host-context(.aulani) .resort-arrival-mod-flow-dme .page-section, :host-context(.aulani) .resort-arrival-mod-flow-ndme .page-section, :host-context(.aulani) .resort-arrival-info .page-section {
  zoom: 1;
}
:host-context(.aulani) .clearfix:after, :host-context(.wdw):host-context(.aulani) .resort-arrival-mod-flow-dme .page-section:after, :host-context(.aulani) .resort-arrival-mod-flow-ndme .page-section:after, :host-context(.aulani) .resort-arrival-info .page-section:after {
  clear: both;
}
:host-context(.aulani) .clearfix:after, :host-context(.wdw):host-context(.aulani) .resort-arrival-mod-flow-dme .page-section:after, :host-context(.aulani) .resort-arrival-mod-flow-ndme .page-section:after, :host-context(.aulani) .resort-arrival-info .page-section:after, :host-context(.aulani) .clearfix:before, :host-context(.wdw):host-context(.aulani) .resort-arrival-mod-flow-dme .page-section:before, :host-context(.aulani) .resort-arrival-mod-flow-ndme .page-section:before, :host-context(.aulani) .resort-arrival-info .page-section:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host-context(.aulani) .float-left, :host-context(.wdw):host-context(.aulani) .resort-arrival-mod-flow-dme .left-section, :host-context(.aulani) .resort-arrival-info .left-section {
  float: left;
}
:host-context(.aulani) .float-right {
  float: right;
}
:host-context(.aulani) html,
:host-context(.aulani) body,
:host-context(.aulani) div,
:host-context(.aulani) span,
:host-context(.aulani) object,
:host-context(.aulani) iframe,
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5,
:host-context(.aulani) h6,
:host-context(.aulani) p,
:host-context(.aulani) blockquote,
:host-context(.aulani) pre,
:host-context(.aulani) abbr,
:host-context(.aulani) address,
:host-context(.aulani) address,
:host-context(.aulani) cite,
:host-context(.aulani) code,
:host-context(.aulani) del,
:host-context(.aulani) dfn,
:host-context(.aulani) em,
:host-context(.aulani) img,
:host-context(.aulani) ins,
:host-context(.aulani) kbd,
:host-context(.aulani) q,
:host-context(.aulani) samp,
:host-context(.aulani) small,
:host-context(.aulani) strong,
:host-context(.aulani) sub,
:host-context(.aulani) sup,
:host-context(.aulani) var,
:host-context(.aulani) b,
:host-context(.aulani) i,
:host-context(.aulani) dl,
:host-context(.aulani) dt,
:host-context(.aulani) dd,
:host-context(.aulani) ol,
:host-context(.aulani) ul,
:host-context(.aulani) li,
:host-context(.aulani) fieldset,
:host-context(.aulani) form,
:host-context(.aulani) label,
:host-context(.aulani) legend,
:host-context(.aulani) table,
:host-context(.aulani) caption,
:host-context(.aulani) tbody,
:host-context(.aulani) tfoot,
:host-context(.aulani) thead,
:host-context(.aulani) tr,
:host-context(.aulani) th,
:host-context(.aulani) td,
:host-context(.aulani) article,
:host-context(.aulani) aside,
:host-context(.aulani) canvas,
:host-context(.aulani) details,
:host-context(.aulani) figcaption,
:host-context(.aulani) figure,
:host-context(.aulani) footer,
:host-context(.aulani) header,
:host-context(.aulani) hgroup,
:host-context(.aulani) menu,
:host-context(.aulani) nav,
:host-context(.aulani) section,
:host-context(.aulani) summary,
:host-context(.aulani) time,
:host-context(.aulani) mark,
:host-context(.aulani) audio,
:host-context(.aulani) video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host-context(.aulani) article,
:host-context(.aulani) aside,
:host-context(.aulani) details,
:host-context(.aulani) figcaption,
:host-context(.aulani) figure,
:host-context(.aulani) footer,
:host-context(.aulani) header,
:host-context(.aulani) hgroup,
:host-context(.aulani) img,
:host-context(.aulani) menu,
:host-context(.aulani) nav,
:host-context(.aulani) section {
  display: block;
}
:host-context(.aulani) ol,
:host-context(.aulani) ul {
  list-style: none;
}
:host-context(.aulani) blockquote,
:host-context(.aulani) q {
  quotes: none;
}
:host-context(.aulani) blockquote :before,
:host-context(.aulani) blockquote :after,
:host-context(.aulani) q :before,
:host-context(.aulani) q :after {
  content: none;
}
:host-context(.aulani) a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host-context(.aulani) table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host-context(.aulani) hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host-context(.aulani) input,
:host-context(.aulani) select {
  vertical-align: middle;
}
:host-context(.aulani) address {
  font-style: normal;
}
:host-context(.aulani) input::-ms-clear {
  display: none;
}
:host-context(.aulani) button {
  background: none;
  border: 0;
  padding: 0;
}
:host-context(.aulani) .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host-context(.aulani) .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host-context(.aulani) .resort-arrival-info {
  padding: 32px 0 0 36px;
}
:host-context(.aulani) .resort-arrival-info h3 {
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  letter-spacing: 0;
  color: #382613;
  font-family: "InspireTWDCBook";
  padding-left: 40px;
}
:host-context(.aulani) .resort-arrival-info .left-section {
  width: 100%;
}
:host-context(.aulani) .resort-arrival-info .left-section span.di {
  position: absolute;
  width: 30px;
  height: 30px;
  font-family: Peptasia-MessagingHelpSupport;
  top: 0;
  font-size: 21px;
  color: #382613;
  padding-top: 2px;
}
:host-context(.aulani) .resort-arrival-info .left-section .resort-checkin-time {
  clear: both;
  width: 600px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  letter-spacing: 0;
  color: #69645E;
  font-family: "InspireTWDCBook";
}
:host-context(.aulani) .resort-arrival-info .left-section .input-container {
  --font16_-_font-size: 12px;
  --font16_-_line-height: 16px;
  --font-light_-_font-family: InspireTWDCRoman;
}
:host-context(.aulani) .resort-arrival-info .left-section .input-container .single-select-box {
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  letter-spacing: 0;
  --font-light_-_font-family: InspireTWDCRoman;
  color: #867F77;
  float: left;
  width: 100%;
  font-weight: 400;
  z-index: 2;
}
:host-context(.aulani) .resort-arrival-info .left-section .arrival-date {
  width: 600px;
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  color: #382613;
  font-family: "InspireTWDCBook";
  margin-left: 40px;
}
:host-context(.aulani) .resort-arrival-info .border-section {
  margin: 32px 0 0;
  border-bottom: thin solid #918F8C;
  width: 100%;
}
:host-context(.aulani) .resort-arrival-info .border-section.hide-border {
  border-bottom: none;
}
:host-context(.aulani) .resort-arrival-info .left-section.aulani-content .dropdown-outer-container {
  width: 280px;
  padding: 24px 0 16px 40px;
}
:host-context(.aulani) .resort-arrival-info .left-section.aulani-content .arrival-date {
  margin: 16px 0 0 40px;
  width: 600px;
}
@media only screen and (max-width: 767px) {
  :host-context(.aulani) .resort-arrival-info {
    padding: 32px 20px 0;
  }
  :host-context(.aulani) .resort-arrival-info .left-section.aulani-content h3 {
    font-size: 18px;
    line-height: 27px;
    font-weight: 600;
    letter-spacing: 0;
  }
  :host-context(.aulani) .resort-arrival-info .left-section.aulani-content .dropdown-outer-container {
    width: 100%;
    padding: 16px 0;
  }
  :host-context(.aulani) .resort-arrival-info .left-section.aulani-content .arrival-date {
    margin: 0;
    width: 100%;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
  }
  :host-context(.aulani) .resort-arrival-info .left-section.aulani-content .resort-checkin-time {
    font-size: 14px;
    line-height: 21px;
    font-weight: 400;
    letter-spacing: 0;
    margin: 0;
    width: 100%;
  }
}
@media (min-width: 767px) {
  :host-context(.aulani) .resort-arrival-info {
    clear: both;
  }
  :host-context(.aulani) .resort-arrival-info .left-section {
    width: calc(100% - 198px);
  }
  :host-context(.aulani) .resort-arrival-info .left-section .input-container {
    --font16_-_font-size: 16px;
    --font16_-_line-height: 28px;
    --font-light_-_font-family: InspireTWDCHeavy;
  }
  :host-context(.aulani) .resort-arrival-info .left-section .input-container .single-select-box {
    --font-light_-_font-family: InspireTWDCHeavy;
    margin-left: 40px;
    height: 46px;
    width: 250px;
    z-index: 2;
  }
  :host-context(.aulani) .resort-arrival-info .left-section span {
    width: 34px;
    height: 34px;
    font-size: 24px;
    line-height: 24px;
  }
  :host-context(.aulani) .resort-arrival-info .left-section .arrival-date {
    margin-left: 40px;
  }
  :host-context(.aulani) .resort-arrival-info .left-section .resort-checkin-time {
    margin-left: 40px;
    color: #69645E;
  }
  :host-context(.aulani) .resort-arrival-info .left-section .resort-arrival-error-msg {
    margin-left: 40px;
  }
  :host-context(.aulani) .resort-arrival-info .border-section {
    margin: 32px 0 0;
    width: 100%;
    background-image: none;
    border-bottom: thin solid #918F8C;
  }
}
:host-context(.aulani) .resort-arrival-mod-flow-ndme {
  margin-left: 40px;
  padding: 28px 0 0;
  width: 100%;
  clear: both;
}
:host-context(.aulani) .resort-arrival-mod-flow-ndme .page-section {
  display: flex;
  margin-right: 40px;
}
:host-context(.aulani) .resort-arrival-mod-flow-ndme .border-section {
  margin: 28px 40px 0 0;
  height: 1px;
  border-bottom: thin solid #918F8C;
  background-image: none;
}
:host-context(.aulani) .resort-arrival-mod-flow-ndme .left-section {
  float: left;
  width: 100%;
}
:host-context(.aulani) .resort-arrival-mod-flow-ndme .left-section span {
  position: absolute;
  width: 24px;
  height: 24px;
  font-family: Peptasia-MessagingHelpSupport;
  top: 2px;
  font-size: 21px;
  color: #382613;
}
:host-context(.aulani) .resort-arrival-mod-flow-ndme .left-section h3 {
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
  letter-spacing: 0;
  color: #382613;
  font-family: "InspireTWDCHeavy";
  padding-left: 40px;
  margin-bottom: 10px;
}
:host-context(.aulani) .resort-arrival-mod-flow-ndme .left-section h3.collapsed {
  margin: 0;
}
:host-context(.aulani) .resort-arrival-mod-flow-ndme .left-section .requested-wrap {
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  color: #382613;
  font-family: "InspireTWDCRoman";
  margin-left: 40px;
}
:host-context(.aulani) .resort-arrival-mod-flow-ndme .right-section {
  float: right;
  text-align: right;
  margin-top: 35px;
}
:host-context(.aulani) .resort-arrival-mod-flow-ndme .right-section .section-edit {
  font-family: "InspireTWDCMedium";
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  letter-spacing: 0;
  color: #B73C00;
  font-weight: 600;
  cursor: pointer;
}
:host-context(.aulani) .resort-arrival-mod-flow-ndme .right-section .section-edit:hover {
  color: #7C3813;
}
:host-context(.aulani) .resort-arrival-mod-flow-ndme .right-section .section-edit:focus {
  color: #B73C00;
  outline: 2px solid #B73C00;
  outline-offset: 4px;
}
:host-context(.aulani) .resort-arrival-mod-flow-ndme .select-wrap {
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  color: #382613;
  font-family: "InspireTWDCRoman";
  margin-left: 40px;
}
:host-context(.aulani) .resort-arrival-mod-flow-ndme .select-wrap .arrival-date {
  width: 600px;
}
:host-context(.aulani) .resort-arrival-mod-flow-ndme .select-wrap .dropdown-outer-container {
  font-family: "InspireTWDCRoman";
  margin: 10px 0 24px;
  width: 300px;
}
:host-context(.aulani) .resort-arrival-mod-flow-ndme .select-wrap .resort-checkin-time {
  width: 600px;
  clear: both;
}
@media only screen and (max-width: 767px) {
  :host-context(.aulani) .resort-arrival-mod-flow-ndme {
    padding: 16px 0 0;
    margin-left: 35px;
  }
  :host-context(.aulani) .resort-arrival-mod-flow-ndme .border-section {
    margin: 16px 32px 0 0;
  }
  :host-context(.aulani) .resort-arrival-mod-flow-ndme .page-section {
    margin-right: 35px;
  }
  :host-context(.aulani) .resort-arrival-mod-flow-ndme .left-section h3 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: 0;
    color: #382613;
    font-family: "InspireTWDCHeavy";
    padding-left: 40px;
  }
  :host-context(.aulani) .resort-arrival-mod-flow-ndme .left-section .requested-wrap {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
    margin: 0 32px 0 40px;
  }
  :host-context(.aulani) .resort-arrival-mod-flow-ndme .right-section {
    margin-top: 0;
  }
  :host-context(.aulani) .resort-arrival-mod-flow-ndme .right-section .section-edit {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: 0;
  }
  :host-context(.aulani) .resort-arrival-mod-flow-ndme .select-wrap {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
    margin: 0 32px 0 40px;
  }
  :host-context(.aulani) .resort-arrival-mod-flow-ndme .select-wrap .arrival-date {
    width: 100%;
  }
  :host-context(.aulani) .resort-arrival-mod-flow-ndme .select-wrap .dropdown-outer-container {
    margin: 10px 0 26px;
    width: 100%;
  }
  :host-context(.aulani) .resort-arrival-mod-flow-ndme .select-wrap .resort-checkin-time {
    width: 100%;
  }
}

:host-context(.wdw) {
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
  /* For Desktop */
  --wdpr-single-select-border-width: 0 0 2px 0;
  --font-light_-_font-family: InspireTWDCRoman;
  --primary-dark: #78899E;
  --wdpr-single-select-border-color: #A1AFC0;
}
:host-context(.wdw) * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host-context(.wdw) *:before, :host-context(.wdw) *:after {
  box-sizing: border-box;
}
:host-context(.wdw) *:focus {
  outline: 1px dotted #000;
}
:host-context(.wdw) html,
:host-context(.wdw) body {
  margin: 0;
  min-height: 100vh;
}
:host-context(.wdw) body {
  width: 100%;
}
:host-context(.wdw) img {
  width: 100%;
}
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5 {
  margin: 0;
}
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5,
:host-context(.wdw) h6,
:host-context(.wdw) span,
:host-context(.wdw) a,
:host-context(.wdw) li,
:host-context(.wdw) p,
:host-context(.wdw) input,
:host-context(.wdw) textarea {
  font-family: inherit;
}
:host-context(.wdw) .clearfix, :host-context(.wdw) .resort-arrival-mod-flow-dme .page-section, :host-context(.wdw) .resort-arrival-mod-flow-ndme .page-section, :host-context(.wdw) .resort-arrival-info .page-section {
  zoom: 1;
}
:host-context(.wdw) .clearfix:after, :host-context(.wdw) .resort-arrival-mod-flow-dme .page-section:after, :host-context(.wdw) .resort-arrival-mod-flow-ndme .page-section:after, :host-context(.wdw) .resort-arrival-info .page-section:after {
  clear: both;
}
:host-context(.wdw) .clearfix:after, :host-context(.wdw) .resort-arrival-mod-flow-dme .page-section:after, :host-context(.wdw) .resort-arrival-mod-flow-ndme .page-section:after, :host-context(.wdw) .resort-arrival-info .page-section:after, :host-context(.wdw) .clearfix:before, :host-context(.wdw) .resort-arrival-mod-flow-dme .page-section:before, :host-context(.wdw) .resort-arrival-mod-flow-ndme .page-section:before, :host-context(.wdw) .resort-arrival-info .page-section:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host-context(.wdw) .float-left, :host-context(.wdw) .resort-arrival-mod-flow-dme .left-section, :host-context(.wdw) .resort-arrival-info .left-section {
  float: left;
}
:host-context(.wdw) .float-right {
  float: right;
}
:host-context(.wdw) html,
:host-context(.wdw) body,
:host-context(.wdw) div,
:host-context(.wdw) span,
:host-context(.wdw) object,
:host-context(.wdw) iframe,
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5,
:host-context(.wdw) h6,
:host-context(.wdw) p,
:host-context(.wdw) blockquote,
:host-context(.wdw) pre,
:host-context(.wdw) abbr,
:host-context(.wdw) address,
:host-context(.wdw) address,
:host-context(.wdw) cite,
:host-context(.wdw) code,
:host-context(.wdw) del,
:host-context(.wdw) dfn,
:host-context(.wdw) em,
:host-context(.wdw) img,
:host-context(.wdw) ins,
:host-context(.wdw) kbd,
:host-context(.wdw) q,
:host-context(.wdw) samp,
:host-context(.wdw) small,
:host-context(.wdw) strong,
:host-context(.wdw) sub,
:host-context(.wdw) sup,
:host-context(.wdw) var,
:host-context(.wdw) b,
:host-context(.wdw) i,
:host-context(.wdw) dl,
:host-context(.wdw) dt,
:host-context(.wdw) dd,
:host-context(.wdw) ol,
:host-context(.wdw) ul,
:host-context(.wdw) li,
:host-context(.wdw) fieldset,
:host-context(.wdw) form,
:host-context(.wdw) label,
:host-context(.wdw) legend,
:host-context(.wdw) table,
:host-context(.wdw) caption,
:host-context(.wdw) tbody,
:host-context(.wdw) tfoot,
:host-context(.wdw) thead,
:host-context(.wdw) tr,
:host-context(.wdw) th,
:host-context(.wdw) td,
:host-context(.wdw) article,
:host-context(.wdw) aside,
:host-context(.wdw) canvas,
:host-context(.wdw) details,
:host-context(.wdw) figcaption,
:host-context(.wdw) figure,
:host-context(.wdw) footer,
:host-context(.wdw) header,
:host-context(.wdw) hgroup,
:host-context(.wdw) menu,
:host-context(.wdw) nav,
:host-context(.wdw) section,
:host-context(.wdw) summary,
:host-context(.wdw) time,
:host-context(.wdw) mark,
:host-context(.wdw) audio,
:host-context(.wdw) video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host-context(.wdw) article,
:host-context(.wdw) aside,
:host-context(.wdw) details,
:host-context(.wdw) figcaption,
:host-context(.wdw) figure,
:host-context(.wdw) footer,
:host-context(.wdw) header,
:host-context(.wdw) hgroup,
:host-context(.wdw) img,
:host-context(.wdw) menu,
:host-context(.wdw) nav,
:host-context(.wdw) section {
  display: block;
}
:host-context(.wdw) ol,
:host-context(.wdw) ul {
  list-style: none;
}
:host-context(.wdw) blockquote,
:host-context(.wdw) q {
  quotes: none;
}
:host-context(.wdw) blockquote :before,
:host-context(.wdw) blockquote :after,
:host-context(.wdw) q :before,
:host-context(.wdw) q :after {
  content: none;
}
:host-context(.wdw) a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host-context(.wdw) table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host-context(.wdw) hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host-context(.wdw) input,
:host-context(.wdw) select {
  vertical-align: middle;
}
:host-context(.wdw) address {
  font-style: normal;
}
:host-context(.wdw) input::-ms-clear {
  display: none;
}
:host-context(.wdw) button {
  background: none;
  border: 0;
  padding: 0;
}
:host-context(.wdw) .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host-context(.wdw) .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host-context(.wdw) .resort-arrival-info {
  padding: 30px 10px 0;
}
:host-context(.wdw) .resort-arrival-info h3 {
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  letter-spacing: 0;
  color: #253B56;
  font-family: "InspireTWDCHeavy";
  padding-left: 40px;
  letter-spacing: -0.01px;
  font-weight: 700;
}
:host-context(.wdw) .resort-arrival-info h3 _:default:not(:root:root), :host-context(.wdw) .resort-arrival-info h3.safari_only {
  font-family: "InspireTWDC";
  font-weight: 700;
}
:host-context(.wdw) .resort-arrival-info .left-section {
  width: 100%;
}
:host-context(.wdw) .resort-arrival-info .left-section span {
  position: absolute;
  width: 30px;
  height: 30px;
  font-family: Peptasia-MessagingHelpSupport;
  top: 0;
  font-size: 21px;
  color: #253B56;
  padding-top: 2px;
}
:host-context(.wdw) .resort-arrival-info .left-section .input-container .single-select-box {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  height: 46px;
  width: 100%;
  float: left;
  margin-left: 2px;
  margin-bottom: 1px;
  border-width: 0 0 2px;
  z-index: 2;
}
:host-context(.wdw) .resort-arrival-info .left-section .arrival-date {
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  letter-spacing: 0;
  color: #253B56;
  font-family: "InspireTWDCHeavy";
  padding-left: 2px;
  margin-top: 2px;
}
:host-context(.wdw) .resort-arrival-info .left-section .resort-checkin-time {
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  letter-spacing: 0;
  clear: both;
  color: #253B56;
  font-family: "InspireTWDCMedium";
  padding-left: 4px;
}
:host-context(.wdw) .resort-arrival-info .border-section {
  margin-top: 30px;
  height: 1px;
  border-bottom: thin solid #D8D8D8;
}
:host-context(.wdw) .resort-arrival-mod-flow-ndme {
  padding: 16px 0 0;
  width: 100%;
  clear: both;
}
:host-context(.wdw) .resort-arrival-mod-flow-ndme.expanded {
  padding: 30px 0 0;
}
:host-context(.wdw) .resort-arrival-mod-flow-ndme h3 {
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  letter-spacing: 0;
  color: #253B56;
  font-family: "InspireTWDCHeavy";
  padding-left: 40px;
  letter-spacing: -0.01px;
  font-weight: 700;
}
:host-context(.wdw) .resort-arrival-mod-flow-ndme h3 _:default:not(:root:root), :host-context(.wdw) .resort-arrival-mod-flow-ndme h3.safari_only {
  font-family: "InspireTWDC";
  font-weight: 700;
}
:host-context(.wdw) .resort-arrival-mod-flow-ndme .left-section {
  float: left;
  width: calc(100% - 45px);
}
:host-context(.wdw) .resort-arrival-mod-flow-ndme .left-section span {
  position: absolute;
  width: 30px;
  height: 30px;
  font-family: Peptasia-MessagingHelpSupport;
  top: 0;
  font-size: 21px;
  color: #253B56;
  padding-top: 2px;
}
:host-context(.wdw) .resort-arrival-mod-flow-ndme .right-section {
  float: right;
  text-align: right;
  width: 45px;
  margin-top: 2px;
}
:host-context(.wdw) .resort-arrival-mod-flow-ndme .right-section .section-edit {
  font-family: "InspireTWDCMedium";
  font-size: 12px;
  line-height: 24px;
  font-weight: 500;
  letter-spacing: 0;
  color: #1B96D5;
  cursor: pointer;
}
:host-context(.wdw) .resort-arrival-mod-flow-ndme .select-wrap {
  margin-top: 3px;
}
:host-context(.wdw) .resort-arrival-mod-flow-ndme .select-wrap .label-wrap .input-container .single-select-box {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  height: 46px;
  width: 100%;
  float: left;
  margin-left: 2px;
  margin-bottom: 1px;
  border-width: 0 0 2px;
  z-index: 2;
}
:host-context(.wdw) .resort-arrival-mod-flow-ndme .select-wrap .label-wrap .arrival-date {
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  letter-spacing: 0;
  color: #253B56;
  font-family: "InspireTWDCHeavy";
}
:host-context(.wdw) .resort-arrival-mod-flow-ndme .select-wrap .label-wrap .resort-checkin-time {
  clear: both;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  letter-spacing: 0;
  color: #253B56;
  font-family: "InspireTWDCMedium";
}
:host-context(.wdw) .resort-arrival-mod-flow-ndme .requested-wrap {
  padding-left: 0;
}
:host-context(.wdw) .resort-arrival-mod-flow-ndme .requested-wrap .saved-arrival-time {
  font-size: 12px;
  color: #253B56;
  font-family: "InspireTWDCBook";
  line-height: 20px;
  letter-spacing: 0;
}
:host-context(.wdw) .resort-arrival-mod-flow-ndme .border-section {
  margin: 30px 0 0;
  border-bottom: thin solid #D8D8D8;
  width: 100%;
}
:host-context(.wdw) .resort-arrival-mod-flow-dme {
  padding: 16px 0 0;
  width: 100%;
  clear: both;
}
:host-context(.wdw) .resort-arrival-mod-flow-dme h3 {
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  letter-spacing: 0;
  color: #253B56;
  font-family: "InspireTWDCHeavy";
  padding-left: 40px;
  margin-bottom: 3px;
  letter-spacing: -0.01px;
  font-weight: 700;
}
:host-context(.wdw) .resort-arrival-mod-flow-dme h3 _:default:not(:root:root), :host-context(.wdw) .resort-arrival-mod-flow-dme h3.safari_only {
  font-family: "InspireTWDC";
  font-weight: 700;
}
:host-context(.wdw) .resort-arrival-mod-flow-dme .left-section {
  width: 100%;
}
:host-context(.wdw) .resort-arrival-mod-flow-dme .left-section span {
  position: absolute;
  width: 30px;
  height: 30px;
  font-family: Peptasia-MessagingHelpSupport;
  top: 0;
  font-size: 21px;
  color: #253B56;
  padding-top: 2px;
}
:host-context(.wdw) .resort-arrival-mod-flow-dme .left-section .dme-reservation {
  font-size: 12px;
  font-family: "InspireTWDCBook";
  color: #253B56;
}
:host-context(.wdw) .resort-arrival-mod-flow-dme .border-section {
  margin: 30px 0 0;
  border-bottom: thin solid #D8D8D8;
  width: 100%;
}
@media (min-width: 767px) {
  :host-context(.wdw) .resort-arrival-info {
    padding: 30px 40px 0;
  }
  :host-context(.wdw) .resort-arrival-info h3 {
    padding-left: 40px;
    letter-spacing: -0.01px;
  }
  :host-context(.wdw) .resort-arrival-info .left-section {
    width: calc(100% - 130px);
    padding-right: 28px;
  }
  :host-context(.wdw) .resort-arrival-info .left-section .input-container .single-select-box {
    margin-left: 40px;
    margin-bottom: 1px;
    width: 240px;
    z-index: 2;
  }
  :host-context(.wdw) .resort-arrival-info .left-section span {
    width: 30px;
    height: 30px;
    font-size: 24px;
  }
  :host-context(.wdw) .resort-arrival-info .left-section .arrival-date {
    padding-left: 40px;
  }
  :host-context(.wdw) .resort-arrival-info .left-section .resort-checkin-time {
    padding-left: 40px;
  }
  :host-context(.wdw) .resort-arrival-info .left-section .resort-arrival-error-msg {
    margin-left: 40px;
  }
  :host-context(.wdw) .resort-arrival-mod-flow-ndme .left-section {
    width: calc(100% - 130px);
    padding-right: 28px;
  }
  :host-context(.wdw) .resort-arrival-mod-flow-ndme .left-section span {
    width: 30px;
    height: 30px;
    font-size: 24px;
  }
  :host-context(.wdw) .resort-arrival-mod-flow-ndme .select-wrap {
    padding-left: 40px;
    margin-top: 15px;
    width: calc(100% - 130px);
    padding-right: 28px;
  }
  :host-context(.wdw) .resort-arrival-mod-flow-ndme .select-wrap .label-wrap .input-container .single-select-box {
    margin: 15px 0 8px 0;
    width: 334px;
    z-index: 2;
  }
  :host-context(.wdw) .resort-arrival-mod-flow-ndme .select-wrap .label-wrap .arrival-date {
    width: 100%;
  }
  :host-context(.wdw) .resort-arrival-mod-flow-ndme .requested-wrap {
    padding-left: 40px;
    padding-right: 28px;
    width: calc(100% - 130px);
  }
  :host-context(.wdw) .resort-arrival-mod-flow-dme .left-section {
    width: calc(100% - 130px);
    padding-right: 28px;
  }
  :host-context(.wdw) .resort-arrival-mod-flow-dme .left-section span {
    width: 30px;
    height: 30px;
    font-size: 24px;
  }
  :host-context(.wdw) .resort-arrival-mod-flow-dme .left-section .dme-reservation {
    padding-left: 40px;
  }
}
@media (min-width: 1024px) {
  :host-context(.wdw) .resort-arrival-info {
    padding: 30px 40px 0;
  }
  :host-context(.wdw) .resort-arrival-info h3 {
    padding-left: 40px;
  }
  :host-context(.wdw) .resort-arrival-info .left-section .input-container .single-select-box {
    margin-left: 40px;
    margin-bottom: 1px;
    width: 240px;
    z-index: 2;
  }
  :host-context(.wdw) .resort-arrival-info .left-section span {
    width: 30px;
    height: 30px;
    font-size: 24px;
  }
  :host-context(.wdw) .resort-arrival-info .left-section .arrival-date {
    padding-left: 40px;
  }
  :host-context(.wdw) .resort-arrival-info .left-section .resort-checkin-time {
    padding-left: 40px;
  }
  :host-context(.wdw) .resort-arrival-mod-flow-ndme .left-section span {
    width: 30px;
    height: 30px;
    font-size: 24px;
  }
  :host-context(.wdw) .resort-arrival-mod-flow-ndme .select-wrap {
    margin-top: 3px;
  }
  :host-context(.wdw) .resort-arrival-mod-flow-ndme .select-wrap .label-wrap .input-container .single-select-box {
    margin: 15px 0 8px 0;
    width: 334px;
    z-index: 2;
  }
  :host-context(.wdw) .resort-arrival-mod-flow-ndme .select-wrap .label-wrap .arrival-date {
    width: 100%;
  }
  :host-context(.wdw) .resort-arrival-mod-flow-ndme .requested-wrap {
    padding-left: 40px;
  }
  :host-context(.wdw) .resort-arrival-mod-flow-dme .left-section span {
    width: 30px;
    height: 30px;
    font-size: 24px;
  }
  :host-context(.wdw) .resort-arrival-mod-flow-dme .left-section .dme-reservation {
    padding-left: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/resort-arrival/resort-arrival.component.scss","webpack://./src/assets/style/theme/index.scss","webpack://./src/assets/style/abstracts/variables.scss","webpack://./src/assets/style/abstracts/functions.scss","webpack://./src/assets/style/abstracts/mixins.scss","webpack://./src/assets/style/base/global.scss","webpack://./src/assets/style/base/reset.scss","webpack://./src/app/resort-arrival/resort-arrival.component.aulani.scss","webpack://./src/assets/style/base/font.scss","webpack://./src/assets/style/base.scss","webpack://./src/app/resort-arrival/resort-arrival.component.wdw.scss"],"names":[],"mappings":"AAEA;ECFA,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;EC6FA,uBAAA;EA6BA,gBAAA;EPrHI,uBAAA;EACA,mCAAA;EACA,wCAAA;EACA,oDAAA;EACA,gCAAA;EACA,6BAAA;EACA,0BAAA;EACA,wDAAA;EACA,uCAAA;EACA,0CAAA;EACA,yCAAA;EACA,4CAAA;AAkCJ;AK3CA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;AL6CJ;AK3CI;EAEI,sBAAA;AL4CR;AKzCI;EACI,wBAAA;AL2CR;AKvCA;;EAEI,SAAA;EACA,iBAAA;ALyCJ;AKtCA;EACI,WAAA;ALwCJ;AKrCA;EACI,WAAA;ALuCJ;AKpCA;;;;;EAKI,SAAA;ALsCJ;AKnCA;;;;;;;;;;;;EAYI,oBAAA;ALqCJ;AKlCA;EACI,OAAA;ALoCJ;AKlCI;EACI,WAAA;ALoCR;AKjCI;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ALkCR;AK9BA;EACI,WAAA;ALgCJ;AK7BA;EACI,YAAA;AL+BJ;AM/GA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;ANiHJ;AM9GA;;;;;;;;;;;;EAYI,cAAA;ANgHJ;AM7GA;;EAEI,gBAAA;AN+GJ;AM5GA;;EAEI,YAAA;AN8GJ;AM5GI;;;;EAEI,aAAA;ANgHR;AM5GA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AN8GJ;AM3GA;EACI,yBAAA;EACA,iBAAA;AN6GJ;AM1GA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AN4GJ;AMzGA;;EAEI,sBAAA;AN2GJ;AMxGA;EACI,kBAAA;AN0GJ;AMtGI;EACI,aAAA;ANwGR;AMpGA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;ANsGJ;AMjGQ;EACI,gBAAA;EACA,cAAA;ANmGZ;AM/FY;EACI,cAAA;ANiGhB;AOnQA;EACI,sBAAA;APqQJ;AO/PI;EHUA,eGTkB;EHUlB,iBGVwB;EHWxB,gBGX8B;EHY9B,iBAJqE;EGPjE,cNcoB;EMbpB,8BCdgB;EDehB,kBAZe;APgRvB;AOjQI;EAEI,WAAA;APkQR;AOhQQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,MAAA;EACA,eAAA;EACA,cNFgB;EMGhB,gBAAA;APkQZ;AO/PQ;EACI,WAAA;EACA,YE5BY;ELcpB,eGgBsB;EHftB,iBGe4B;EHd5B,gBGckC;EHblC,iBAJqE;EGkB7D,cNVa;EMWb,8BCvCY;AR0SxB;AOhQQ;EACI,0BAAA;EACA,4BAAA;EACA,4CAAA;APkQZ;AOhQY;EH1BR,eG2B0B;EH1B1B,iBG0BgC;EHzBhC,gBAH+C;EAI/C,iBAJqE;EG6BzD,4CAAA;EACA,cN3Bc;EM4Bd,WAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;APqQhB;AOjQQ;EACI,YEpDY;ELcpB,eGuCsB;EHtCtB,iBGsC4B;EHrC5B,gBGqCkC;EHpClC,iBAJqE;EGyC7D,cNlCgB;EMmChB,8BC9DY;ED+DZ,iBA5DW;APkUvB;AOlQI;EACI,gBAAA;EACA,iCNhDgB;EMiDhB,WAAA;APoQR;AOlQQ;EACI,mBAAA;APoQZ;AO5PQ;EACI,YAAA;EACA,yBAAA;AP8PZ;AO5PQ;EACI,qBAAA;EACA,YEhFY;AT8UxB;AOxPA;EACI;IACI,oBAAA;EP0PN;EOtPc;IH9EZ,eG+E8B;IH9E9B,iBG8EoC;IH7EpC,gBG6E0C;IH5E1C,iBAJqE;EJ2UvE;EOzPc;IACI,WAAA;IACA,eAAA;EP2PlB;EOzPc;IACI,SAAA;IACA,WAAA;IHvFhB,eGwF8B;IHvF9B,iBGuFoC;IHtFpC,gBGsF0C;IHrF1C,iBAJqE;EJuVvE;EO5Pc;IH1FZ,eG2F8B;IH1F9B,iBG0FoC;IHzFpC,gBGyF0C;IHxF1C,iBAJqE;IG6FrD,SAAA;IACA,WAAA;EPiQlB;AACF;AO1PA;EACI;IACI,WAAA;EP4PN;EO1PM;IACI,yBAAA;EP4PV;EO1PU;IACI,0BAAA;IACA,4BAAA;IACA,4CAAA;EP4Pd;EO1Pc;IACI,4CAAA;IACA,iBArIG;IAsIH,YAAA;IACA,YAAA;IACA,UAAA;EP4PlB;EOxPU;IACI,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EP0Pd;EOvPU;IACI,iBApJO;EP6YrB;EOtPU;IACI,iBAxJO;IAyJP,cNhIS;EDwXvB;EOrPU;IACI,iBA7JO;EPoZrB;EOnPM;IACI,gBAAA;IACA,WAAA;IACA,sBAAA;IACA,iCNnJY;EDwYtB;AACF;AOhPA;EACI,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;APkPJ;AOhPI;EAEI,aAAA;EACA,kBAAA;APiPR;AO9OI;EACI,qBAAA;EACA,WAAA;EACA,iCNxKgB;EMyKhB,sBAAA;APgPR;AO7OI;EH/JA,WAAA;EGiKI,WAAA;AP+OR;AO7OQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,QAAA;EACA,eAAA;EACA,cNjLgB;ADga5B;AO5OQ;EH1LJ,eG2LsB;EH1LtB,iBG0L4B;EHzL5B,gBGyLkC;EHxLlC,iBAJqE;EG6L7D,cNtLgB;EMuLhB,+BC/Ma;EDgNb,kBAAA;EACA,mBAAA;APiPZ;AO/OY;EACI,SAAA;APiPhB;AO7OQ;EHtMJ,eGuMsB;EHtMtB,iBGsM4B;EHrM5B,gBGqMkC;EHpMlC,iBAJqE;EGyM7D,cNlMgB;EMmMhB,+BCzNa;ED0Nb,iBA5NW;AP8cvB;AO9OI;EH7LA,YAAA;EG+LI,iBAAA;EACA,gBAAA;APgPR;AO9OQ;EACI,gCCvOc;EJmBtB,eGqNsB;EHpNtB,iBGoN4B;EHnN5B,gBGmNkC;EHlNlC,iBAJqE;EAsBrE,cHvBkB;EGwBlB,gBAAA;EGiMQ,eAAA;APoPZ;AInbI;EACI,cALyC;AJ0bjD;AIlbI;EACI,cH/Bc;EGgCd,0BAAA;EACA,mBAAA;AJobR;AOxPI;EH3NA,eG4NkB;EH3NlB,iBG2NwB;EH1NxB,gBG0N8B;EHzN9B,iBAJqE;EG8NjE,cNvNoB;EMwNpB,+BC9OiB;ED+OjB,iBAjPe;AP8evB;AO3PQ;EACI,YAAA;AP6PZ;AO1PQ;EACI,+BCtPa;EDuPb,mBAAA;EACA,YAAA;AP4PZ;AOzPQ;EACI,YAAA;EACA,WAAA;AP2PZ;AOtPA;EACI;IACI,iBAAA;IACA,iBAAA;EPwPN;EOtPM;IACI,qBAAA;EPwPV;EOrPM;IACI,kBAAA;EPuPV;EOnPU;IHhQR,eGiQ0B;IHhQ1B,iBGgQgC;IH/PhC,gBG+PsC;IH9PtC,iBAJqE;IGmQzD,cN5PY;IM6PZ,+BCrRS;IDsRT,kBAAA;EPwPd;EOrPU;IHvQR,eGwQ0B;IHvQ1B,iBGuQgC;IHtQhC,gBGsQsC;IHrQtC,iBAJqE;IG0QzD,qBAAA;EP0Pd;EOtPM;IACI,aAAA;EPwPV;EOtPU;IHhRR,eGiR0B;IHhR1B,iBGgRgC;IH/QhC,gBG+QsC;IH9QtC,iBAJqE;EJ6gBvE;EOvPM;IHrRJ,eGsRsB;IHrRtB,iBGqR4B;IHpR5B,gBGoRkC;IHnRlC,iBAJqE;IGwR7D,qBAAA;EP4PV;EO1PU;IACI,WAAA;EP4Pd;EOzPU;IACI,mBAAA;IACA,WAAA;EP2Pd;EOxPU;IACI,WAAA;EP0Pd;AACF;;AAjiBA;ECnBA,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;EIoPA,gBAAA;EV9NI,4CAAA;EACA,4CAAA;EACA,uBAAA;EACA,0CAAA;AAskBJ;AKxlBA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;AL0lBJ;AKxlBI;EAEI,sBAAA;ALylBR;AKtlBI;EACI,wBAAA;ALwlBR;AKplBA;;EAEI,SAAA;EACA,iBAAA;ALslBJ;AKnlBA;EACI,WAAA;ALqlBJ;AKllBA;EACI,WAAA;ALolBJ;AKjlBA;;;;;EAKI,SAAA;ALmlBJ;AKhlBA;;;;;;;;;;;;EAYI,oBAAA;ALklBJ;AK/kBA;EACI,OAAA;ALilBJ;AK/kBI;EACI,WAAA;ALilBR;AK9kBI;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AL+kBR;AK3kBA;EACI,WAAA;AL6kBJ;AK1kBA;EACI,YAAA;AL4kBJ;AM5pBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;AN8pBJ;AM3pBA;;;;;;;;;;;;EAYI,cAAA;AN6pBJ;AM1pBA;;EAEI,gBAAA;AN4pBJ;AMzpBA;;EAEI,YAAA;AN2pBJ;AMzpBI;;;;EAEI,aAAA;AN6pBR;AMzpBA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AN2pBJ;AMxpBA;EACI,yBAAA;EACA,iBAAA;AN0pBJ;AMvpBA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;ANypBJ;AMtpBA;;EAEI,sBAAA;ANwpBJ;AMrpBA;EACI,kBAAA;ANupBJ;AMnpBI;EACI,aAAA;ANqpBR;AMjpBA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;ANmpBJ;AM9oBQ;EACI,gBAAA;EACA,cAAA;ANgpBZ;AM5oBY;EACI,cAAA;AN8oBhB;AUjzBA;EAII,oBAAA;AVgzBJ;AU9yBI;ENYA,eMXkB;ENYlB,iBMZwB;ENaxB,gBAH+C;EAI/C,iBAJqE;EMTjE,cTLiB;ESMjB,+BFTiB;EEUjB,kBAAA;EACA,uBAAA;EACA,gBAAA;AVmzBR;AUjzBQ;EAEI,0BFpBO;EEqBP,gBAAA;AVkzBZ;AU9yBI;EAEI,WAAA;AV+yBR;AU7yBQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,MAAA;EACA,eAAA;EACA,cT7Ba;ES8Bb,gBAAA;AV+yBZ;AU3yBY;ENnBR,eMoB0B;ENnB1B,iBMmBgC;ENlBhC,gBAH+C;EAI/C,iBAJqE;EMsBzD,+BFrCS;EEsCT,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;AVgzBhB;AU5yBQ;ENhCJ,eMiCsB;ENhCtB,iBMgC4B;EN/B5B,gBAH+C;EAI/C,iBAJqE;EMmC7D,cTjDa;ESkDb,+BFrDa;EEsDb,iBAAA;EACA,eAAA;AVizBZ;AU9yBQ;ENxCJ,eMyCsB;ENxCtB,iBMwC4B;ENvC5B,gBAH+C;EAI/C,iBAJqE;EM2C7D,WAAA;EACA,cT1Da;ES2Db,gCF/Dc;EEgEd,iBAAA;AVmzBZ;AU/yBI;EACI,gBAAA;EACA,WAAA;EACA,iCTjES;ADk3BjB;AU7yBA;EACI,iBAAA;EACA,WAAA;EACA,WAAA;AV+yBJ;AU7yBI;EACI,iBAAA;AV+yBR;AUxyBI;ENrEA,eMsEkB;ENrElB,iBMqEwB;ENpExB,gBAH+C;EAI/C,iBAJqE;EMwEjE,cTtFiB;ESuFjB,+BF1FiB;EE2FjB,kBAAA;EACA,uBAAA;EACA,gBAAA;AV6yBR;AU3yBQ;EAEI,0BFrGO;EEsGP,gBAAA;AV4yBZ;AUxyBI;ENvEA,WAAA;EMyEI,wBAAA;AV0yBR;AUxyBQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,MAAA;EACA,eAAA;EACA,cT9Ga;ES+Gb,gBAAA;AV0yBZ;AUtyBI;ENnFA,YAAA;EMqFI,iBAAA;EACA,WAAA;EACA,eAAA;AVwyBR;AUtyBQ;EACI,gCF9Hc;EJmBtB,eM6GsB;EN5GtB,iBM4G4B;EN3G5B,gBM2GkC;EN1GlC,iBM0GuC;EAC/B,cAAA;EACA,eAAA;AV0yBZ;AUtyBI;EACI,eAAA;AVwyBR;AUpyBgB;ENxHZ,eMyH8B;ENxH9B,iBMwHoC;ENvHpC,gBAH+C;EAI/C,iBAJqE;EM2HrD,+BF1IK;EE2IL,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;AVyyBpB;AUryBY;ENrIR,eMsI0B;ENrI1B,iBMqIgC;ENpIhC,gBAH+C;EAI/C,iBAJqE;EMwIzD,cTtJS;ESuJT,+BF1JS;ARo8BzB;AUvyBY;EACI,WAAA;EN5IZ,eM8I0B;EN7I1B,iBM6IgC;EN5IhC,gBAH+C;EAI/C,iBAJqE;EMgJzD,cT9JS;ES+JT,gCFnKU;AR88B1B;AUtyBI;EACI,eAAA;AVwyBR;AUtyBQ;EACI,eAAA;EACA,cTzKa;ES0Kb,8BFhLY;EEiLZ,iBAAA;EACA,iBAAA;AVwyBZ;AUpyBI;EACI,gBAAA;EACA,iCThLS;ESiLT,WAAA;AVsyBR;AUlyBA;EACI,iBAAA;EACA,WAAA;EACA,WAAA;AVoyBJ;AU9xBI;ENjLA,eMkLkB;ENjLlB,iBMiLwB;ENhLxB,gBAH+C;EAI/C,iBAJqE;EMoLjE,cTlMiB;ESmMjB,+BFtMiB;EEuMjB,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;AVmyBR;AUjyBQ;EAEI,0BFlNO;EEmNP,gBAAA;AVkyBZ;AU9xBI;EAEI,WAAA;AV+xBR;AU7xBQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,MAAA;EACA,eAAA;EACA,cT3Na;ES4Nb,gBAAA;AV+xBZ;AU5xBQ;EACI,eAAA;EACA,8BFvOY;EEwOZ,cTlOa;ADggCzB;AU1xBI;EACI,gBAAA;EACA,iCTtOS;ESuOT,WAAA;AV4xBR;AUvxBA;EACI;IACI,oBAAA;EVyxBN;EUvxBM;IACI,kBAAA;IACA,uBAAA;EVyxBV;EUtxBM;IACI,yBAAA;IACA,mBAAA;EVwxBV;EUrxBc;IACI,iBAAA;IACA,kBAAA;IACA,YAAA;IACA,UAAA;EVuxBlB;EUnxBU;IACI,WAAA;IACA,YAAA;IACA,eAAA;EVqxBd;EUlxBU;IACI,kBAAA;EVoxBd;EUjxBU;IACI,kBAAA;EVmxBd;EUhxBU;IACI,iBAAA;EVkxBd;EU5wBM;IACI,yBAAA;IACA,mBAAA;EV8wBV;EU5wBU;IACI,WAAA;IACA,YAAA;IACA,eAAA;EV8wBd;EU1wBM;IACI,kBAAA;IACA,gBAAA;IACA,yBAAA;IACA,mBAAA;EV4wBV;EUxwBkB;IACI,oBAAA;IACA,YAAA;IACA,UAAA;EV0wBtB;EUtwBc;IACI,WAAA;EVwwBlB;EUnwBM;IACI,kBAAA;IACA,mBAAA;IACA,yBAAA;EVqwBV;EUhwBM;IACI,yBAAA;IACA,mBAAA;EVkwBV;EUhwBU;IACI,WAAA;IACA,YAAA;IACA,eAAA;EVkwBd;EU/vBU;IACI,kBAAA;EViwBd;AACF;AU5vBA;EACI;IACI,oBAAA;EV8vBN;EU5vBM;IACI,kBAAA;EV8vBV;EUzvBc;IACI,iBAAA;IACA,kBAAA;IACA,YAAA;IACA,UAAA;EV2vBlB;EUvvBU;IACI,WAAA;IACA,YAAA;IACA,eAAA;EVyvBd;EUtvBU;IACI,kBAAA;EVwvBd;EUrvBU;IACI,kBAAA;EVuvBd;EUhvBU;IACI,WAAA;IACA,YAAA;IACA,eAAA;EVkvBd;EU9uBM;IACI,eAAA;EVgvBV;EU5uBkB;IACI,oBAAA;IACA,YAAA;IACA,UAAA;EV8uBtB;EU1uBc;IACI,WAAA;EV4uBlB;EUvuBM;IACI,kBAAA;EVyuBV;EUnuBU;IACI,WAAA;IACA,YAAA;IACA,eAAA;EVquBd;EUluBU;IACI,kBAAA;EVouBd;AACF","sourcesContent":["@import '../../assets/style/base/font.scss';\r\n\r\n:host-context(.aulani) {\r\n    @import './resort-arrival.component.aulani';\r\n\r\n    --primary-dark: #867F77;\r\n    --wdpr-single-select-icon-top: 10px;\r\n    --wdpr-single-select-icon-color: #BBB5B0;\r\n    --wdpr-single-select-custom-option-item-height: 24px;\r\n    --secondary-hover-theme: #B14308;\r\n    --primary-dark-theme: #D04901;\r\n    --secondary-hover: #B14308;\r\n    --wdpr-select-all-button-background-color-hover: #B14308;\r\n    --wdpr-select-item-color-hover: #B14308;\r\n    --wdpr-single-select-active-color: #867F77;\r\n    --wdpr-single-select-label-line-height: 0;\r\n    --wdpr-single-select-border-width: 0 0 2px 0;\r\n}\r\n\r\n:host-context(.wdw) {\r\n    @import './resort-arrival.component.wdw';\r\n\r\n    --wdpr-single-select-border-width: 0 0 2px 0;\r\n    --font-light_-_font-family: #{$inspiretwdc-roman-font};\r\n    --primary-dark: #78899E;\r\n    --wdpr-single-select-border-color: #A1AFC0;\r\n}\r\n","/* WDW COLOR CODE */\r\n\r\n$page-background: #E8EDF0;\r\n$primary-color: #FFF;\r\n$primary-shadow: 0 0 4px 0 rgba(37, 59, 86, 0.5);\r\n$secondary-color: #0470AB;\r\n$wdw-primary-message-text-color: #78899E;\r\n$wdw-primary-text-color: #253B56;\r\n$wdw-h3-heading: #424B5A;\r\n$primary-border: thin solid #D8D8D8;\r\n$primary-wdw-link: #1994D7;\r\n$secondary-wdw-link: #1B96D5;\r\n$wdw-message-span: #130026;\r\n$wdw-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$wdw-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$wdw-breadcrumbs-next-color: #73A4BF;\r\n$wdw-disabled-color: #BADFF3;\r\n\r\n/* AULANI COLOR CODE */\r\n$papaya-whitebg-color: #D04901;\r\n$papaya-greybg-color: #B73C00;\r\n$aulani-link-color: #B73C00;\r\n$primary-aulani-border: thin solid #918F8C;\r\n$aulani-border-color: #918F8C;\r\n$aulani-secondary-text-color: #867F77;\r\n$border-background: #FFF;\r\n$primary-aulani-link: #D04901;\r\n$secondary-aulani-link: #D24B00;\r\n$aulani-primary-text-color: #382613;\r\n$aulani-warm-grey-color: #69645E;\r\n$primary-info-text: #8294AA;\r\n$secondary-button-background: #F3EEE6;\r\n$radio-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 15%, #DBDBDB 89%, #FBFBFB 100%);\r\n$footer-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 14%, #DBDBDB 95%, #FBFBFB 100%);\r\n$aulani-hover-link: #B14308;\r\n$aulani-border: radial-gradient($aulani-border-color 0%, #FFF 100%);\r\n$aulani-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$aulani-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$aulani-error-text: #5C4830;\r\n$error-label-color: #FF4605;\r\n$aulani-text-disabed-color: #EFB698;\r\n\r\n$default-button-border: #0079BC;\r\n$default-text-color: #00233C;\r\n$hover-button-border: #006096;\r\n$active-button-border: #083C5D;\r\n$disabled-button-border: #B7E4F7;\r\n","/**\r\n * variables.scss\r\n * Contains the sitewide variables\r\n */\r\n\r\n/**\r\n * Breakpoints variables\r\n */\r\n\r\n$breakpoints: (\r\n    x-small: 0,\r\n    mobile: 320px,\r\n    tablet: 768px,\r\n    desktop: 1024px\r\n);\r\n\r\n$orientations: (\r\n    portrait: portrait,\r\n    landscape: landscape\r\n);\r\n\r\n/**\r\n * Colors variables\r\n */\r\n\r\n$colors: (\r\n    'transparent': transparent,\r\n);\r\n\r\n/**\r\n * z-index variables\r\n */\r\n\r\n$zindex: (\r\n    'base': 1,\r\n    'menu': 2,\r\n    'overlay': 3,\r\n    'modal': 4,\r\n    'toast': 5\r\n);\r\n","/**\r\n * function.scss\r\n * Contains the sitewide functions\r\n */\r\n\r\n@function colors($color) {\r\n    @if not map-has-key($colors, $color) {\r\n        @warn 'No color found for `#{$color}`.';\r\n    }\r\n    \r\n    @return map-get($colors, $color);\r\n}\r\n\r\n@function zindex($layer) {\r\n    @if not map-has-key($zindex, $layer) {\r\n        @warn 'No z-index found for `#{$layer}`.';\r\n    }\r\n    \r\n    @return map-get($zindex, $layer);\r\n}\r\n","/**\r\n * mixins.scss\r\n * Contains the sitewide mixins\r\n */\r\n\r\n@mixin from-breakpoint($bp) {\r\n    @if ($bp == 'x-small') {\r\n        @content;\r\n    }\r\n    @else {\r\n        @if map-has-key($breakpoints, $bp) {\r\n            $list: map-get($breakpoints, $bp);\r\n            $bp: nth($list, 1);\r\n        }\r\n        \r\n        @media screen and (min-width: #{$bp}) {\r\n            @content;\r\n        }\r\n    }\r\n}\r\n\r\n@mixin font($font-size, $line-height, $font-weight:400, $letter-spacing: 0) {\r\n    font-size: $font-size;\r\n    line-height: $line-height;\r\n    font-weight: $font-weight;\r\n    letter-spacing: $letter-spacing;\r\n}\r\n\r\n@mixin host-block() {\r\n    :host {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@mixin float-left() {\r\n    float: left;\r\n}\r\n\r\n@mixin float-right() {\r\n    float: right;\r\n}\r\n\r\n@mixin btn-link($btnColor: #B73C00, $hoverColor: #7C3813) {\r\n    color: $btnColor;\r\n    font-weight: 600;\r\n\r\n    &:hover {\r\n        color: $hoverColor;\r\n    }\r\n\r\n    &:focus {\r\n        color: $btnColor;\r\n        outline: 2px solid $btnColor;\r\n        outline-offset: 4px;\r\n    }\r\n}\r\n","@import '../abstracts/mixins';\r\n\r\n/**\r\n * global.scss\r\n * Contains the sitewide global styles\r\n */\r\n\r\n* {\r\n    background-repeat: no-repeat;\r\n    box-sizing: border-box;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    -webkit-font-smoothing: antialiased;\r\n    position: relative;\r\n    text-rendering: optimizeLegibility;\r\n\r\n    &:before,\r\n    &:after {\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    &:focus {\r\n        outline: 1px dotted #000;\r\n    }\r\n}\r\n\r\nhtml,\r\nbody {\r\n    margin: 0;\r\n    min-height: 100vh;\r\n}\r\n\r\nbody {\r\n    width: 100%;\r\n}\r\n\r\nimg {\r\n    width: 100%;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5 {\r\n    margin: 0;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\nspan,\r\na,\r\nli,\r\np,\r\ninput,\r\ntextarea {\r\n    font-family: inherit;\r\n}\r\n\r\n.clearfix {\r\n    zoom: 1;\r\n\r\n    &:after {\r\n        clear: both;\r\n    }\r\n    \r\n    &:after,\r\n    &:before {\r\n        content: '\\0020';\r\n        display: block;\r\n        overflow: hidden;\r\n        visibility: hidden;\r\n        width: 0;\r\n        height: 0;\r\n    }\r\n}\r\n\r\n.float-left {\r\n    float: left;\r\n}\r\n\r\n.float-right {\r\n    float: right;\r\n}\r\n","/**\r\n * reset.scss\r\n * Contains the sitewide css reset\r\n */\r\n\r\nhtml,\r\nbody,\r\ndiv,\r\nspan,\r\nobject,\r\niframe,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np,\r\nblockquote,\r\npre,\r\nabbr,\r\naddress,\r\naddress,\r\ncite,\r\ncode,\r\ndel,\r\ndfn,\r\nem,\r\nimg,\r\nins,\r\nkbd,\r\nq,\r\nsamp,\r\nsmall,\r\nstrong,\r\nsub,\r\nsup,\r\nvar,\r\nb,\r\ni,\r\ndl,\r\ndt,\r\ndd,\r\nol,\r\nul,\r\nli,\r\nfieldset,\r\nform,\r\nlabel,\r\nlegend,\r\ntable,\r\ncaption,\r\ntbody,\r\ntfoot,\r\nthead,\r\ntr,\r\nth,\r\ntd,\r\narticle,\r\naside,\r\ncanvas,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmenu,\r\nnav,\r\nsection,\r\nsummary,\r\ntime,\r\nmark,\r\naudio,\r\nvideo {\r\n    background: colors('transparent');\r\n    border: 0;\r\n    font-size: 100%;\r\n    margin: 0;\r\n    outline: 0;\r\n    padding: 0;\r\n    vertical-align: baseline;\r\n}\r\n\r\narticle,\r\naside,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nimg,\r\nmenu,\r\nnav,\r\nsection {\r\n    display: block;\r\n}\r\n\r\nol,\r\nul {\r\n    list-style: none;\r\n}\r\n\r\nblockquote,\r\nq {\r\n    quotes: none;\r\n\r\n    :before,\r\n    :after {\r\n        content: none;\r\n    }\r\n}\r\n\r\na {\r\n    background: colors('transparent');\r\n    font-size: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    text-decoration: none;\r\n    touch-action: manipulation;\r\n    vertical-align: baseline;\r\n}\r\n\r\ntable {\r\n    border-collapse: collapse;\r\n    border-spacing: 0;\r\n}\r\n\r\nhr {\r\n    border: 0;\r\n    display: block;\r\n    height: 1px;\r\n    margin: 1em 0;\r\n    padding: 0;\r\n}\r\n\r\ninput,\r\nselect {\r\n    vertical-align: middle;\r\n}\r\n\r\naddress {\r\n    font-style: normal;\r\n}\r\n\r\ninput {\r\n    &::-ms-clear {\r\n        display: none;\r\n    }\r\n}\r\n\r\nbutton {\r\n    background: none;\r\n    border: 0;\r\n    padding: 0;\r\n}\r\n\r\n.aulani {\r\n    .room-ready-terms-and-conditions {\r\n        p a {\r\n            font-weight: 600;\r\n            color: #D04901;\r\n        }\r\n\r\n        &.edit {\r\n            p a {\r\n                color: #B73C00;\r\n            }\r\n        }\r\n    }\r\n}\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n$content-left-padding: 40px;\r\n.resort-arrival-info {\r\n    padding: $common-border-gap 0 0 36px;\r\n\r\n    .page-section {\r\n        @extend .clearfix;\r\n    }\r\n\r\n    h3 {\r\n        @include font(24px, 32px, 600);\r\n        color: $aulani-primary-text-color;\r\n        font-family: $inspiretwdc-book-font;\r\n        padding-left: $content-left-padding;\r\n    }\r\n\r\n    .left-section {\r\n        @extend .float-left;\r\n        width: 100%;\r\n\r\n        span.di {\r\n            position: absolute;\r\n            width: 30px;\r\n            height: 30px;\r\n            font-family: Peptasia-MessagingHelpSupport;\r\n            top: 0;\r\n            font-size: 21px;\r\n            color: $aulani-primary-text-color;\r\n            padding-top: 2px;\r\n        }\r\n\r\n        .resort-checkin-time {\r\n            clear: both;\r\n            width: $desktop-content-width;\r\n\r\n            @include font(16px, 24px, 400);\r\n            color: $aulani-warm-grey-color;\r\n            font-family: $inspiretwdc-book-font;\r\n        }\r\n\r\n        .input-container {\r\n            --font16_-_font-size: 12px;\r\n            --font16_-_line-height: 16px;\r\n            --font-light_-_font-family: #{$inspiretwdc-roman-font};\r\n\r\n            .single-select-box {\r\n                @include font(12px, 16px);\r\n                --font-light_-_font-family: #{$inspiretwdc-roman-font};\r\n                color: $aulani-secondary-text-color;\r\n                float: left;\r\n                width: 100%;\r\n                font-weight: 400;\r\n                z-index: 2;\r\n            }\r\n        }\r\n\r\n        .arrival-date {\r\n            width: $desktop-content-width;\r\n            @include font(18px, 27px, 400);\r\n            color: $aulani-primary-text-color;\r\n            font-family: $inspiretwdc-book-font;\r\n            margin-left: $content-left-padding;\r\n        }\r\n    }\r\n\r\n    .border-section {\r\n        margin: $common-border-gap 0 0;\r\n        border-bottom: $primary-aulani-border;\r\n        width: 100%;\r\n\r\n        &.hide-border {\r\n            border-bottom: none;\r\n        }\r\n    }\r\n}\r\n\r\n// Styles override for new designs\r\n.resort-arrival-info {\r\n    .left-section.aulani-content {\r\n        .dropdown-outer-container {\r\n            width: 280px;\r\n            padding: 24px 0 16px $content-left-padding;\r\n        }\r\n        .arrival-date {\r\n            margin: 16px 0 0 $content-left-padding;\r\n            width: $desktop-content-width;\r\n        }\r\n    }\r\n}\r\n\r\n/* For Mobile devices */\r\n@media only screen and (max-width: 767px) {\r\n    .resort-arrival-info {\r\n        padding: 32px 20px 0;\r\n\r\n        .left-section {\r\n            &.aulani-content {\r\n                h3 {\r\n                    @include font(18px, 27px, 600);\r\n                }\r\n                .dropdown-outer-container {\r\n                    width: 100%;\r\n                    padding: 16px 0;\r\n                }\r\n                .arrival-date {\r\n                    margin: 0;\r\n                    width: 100%;\r\n                    @include font(16px, 24px, 400);\r\n                }\r\n                .resort-checkin-time {\r\n                    @include font(14px, 21px, 400);\r\n                    margin: 0;\r\n                    width: 100%;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/* For Desktop */\r\n@media (min-width: 767px) {\r\n    .resort-arrival-info {\r\n        clear: both;\r\n\r\n        .left-section {\r\n            width: calc(100% - 198px);\r\n\r\n            .input-container {\r\n                --font16_-_font-size: 16px;\r\n                --font16_-_line-height: 28px;\r\n                --font-light_-_font-family: #{$inspiretwdc-heavy-font};\r\n\r\n                .single-select-box {\r\n                    --font-light_-_font-family: #{$inspiretwdc-heavy-font};\r\n                    margin-left: $content-left-padding;\r\n                    height: 46px;\r\n                    width: 250px;\r\n                    z-index: 2;\r\n                }\r\n            }\r\n\r\n            span {\r\n                width: 34px;\r\n                height: 34px;\r\n                font-size: 24px;\r\n                line-height: 24px;\r\n            }\r\n\r\n            .arrival-date {\r\n                margin-left: $content-left-padding;\r\n            }\r\n\r\n            .resort-checkin-time {\r\n                margin-left: $content-left-padding;\r\n                color: $aulani-warm-grey-color;\r\n            }\r\n\r\n            .resort-arrival-error-msg {\r\n                margin-left: $content-left-padding;\r\n            }\r\n        }\r\n\r\n        .border-section {\r\n            margin: 32px 0 0;\r\n            width: 100%;\r\n            background-image: none;\r\n            border-bottom: $primary-aulani-border;\r\n        }\r\n    }\r\n}\r\n\r\n// Edit Section\r\n.resort-arrival-mod-flow-ndme {\r\n    margin-left: 40px;\r\n    padding: 28px 0 0;\r\n    width: 100%;\r\n    clear: both;\r\n\r\n    .page-section {\r\n        @extend .clearfix;\r\n        display: flex;\r\n        margin-right: 40px;\r\n    }\r\n\r\n    .border-section {\r\n        margin: 28px 40px 0 0;\r\n        height: 1px;\r\n        border-bottom: $primary-aulani-border;\r\n        background-image: none;\r\n    }\r\n\r\n    .left-section {\r\n        @include float-left;\r\n        width: 100%;\r\n\r\n        span {\r\n            position: absolute;\r\n            width: 24px;\r\n            height: 24px;\r\n            font-family: Peptasia-MessagingHelpSupport;\r\n            top: 2px;\r\n            font-size: 21px;\r\n            color: $aulani-primary-text-color;\r\n        }\r\n\r\n        h3 {\r\n            @include font(20px, 30px, 600);\r\n            color: $aulani-primary-text-color;\r\n            font-family: $inspiretwdc-heavy-font;\r\n            padding-left: 40px;\r\n            margin-bottom: 10px;\r\n\r\n            &.collapsed {\r\n                margin: 0\r\n            }\r\n        }\r\n\r\n        .requested-wrap {\r\n            @include font(18px, 27px, 400);\r\n            color: $aulani-primary-text-color;\r\n            font-family: $inspiretwdc-roman-font;\r\n            margin-left: $content-left-padding;\r\n        }\r\n    }\r\n\r\n    .right-section {\r\n        @include float-right;\r\n        text-align: right;\r\n        margin-top: 35px;\r\n\r\n        .section-edit {\r\n            font-family: $inspiretwdc-medium-font;\r\n            @include font(18px, 27px, 600);\r\n            @include btn-link($papaya-greybg-color);\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    .select-wrap {\r\n        @include font(18px, 27px, 400);\r\n        color: $aulani-primary-text-color;\r\n        font-family: $inspiretwdc-roman-font;\r\n        margin-left: $content-left-padding;\r\n\r\n        .arrival-date {\r\n            width: 600px;\r\n        }\r\n\r\n        .dropdown-outer-container {\r\n            font-family: $inspiretwdc-roman-font;\r\n            margin: 10px 0 24px;\r\n            width: 300px;\r\n        }\r\n\r\n        .resort-checkin-time {\r\n            width: 600px;\r\n            clear: both;\r\n        }\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 767px) {\r\n    .resort-arrival-mod-flow-ndme {\r\n        padding: 16px 0 0;\r\n        margin-left: 35px;\r\n        \r\n        .border-section {\r\n            margin: 16px 32px 0 0;\r\n        }\r\n\r\n        .page-section {\r\n            margin-right: 35px;\r\n        }\r\n\r\n        .left-section {\r\n            h3 {\r\n                @include font(16px, 24px, 600);\r\n                color: $aulani-primary-text-color;\r\n                font-family: $inspiretwdc-heavy-font;\r\n                padding-left: 40px;\r\n            }\r\n\r\n            .requested-wrap {\r\n                @include font(16px, 24px, 400);\r\n                margin: 0 32px 0 40px;\r\n            }\r\n        }\r\n\r\n        .right-section {\r\n            margin-top: 0;\r\n    \r\n            .section-edit {\r\n                @include font(16px, 24px, 600);\r\n            }\r\n        }\r\n\r\n        .select-wrap {\r\n            @include font(16px, 24px, 400);\r\n            margin: 0 32px 0 40px;\r\n    \r\n            .arrival-date {\r\n                width: 100%;\r\n            }\r\n    \r\n            .dropdown-outer-container {\r\n                margin: 10px 0 26px;\r\n                width: 100%;\r\n            }\r\n    \r\n            .resort-checkin-time {\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n}","$inspiretwdc-font: 'InspireTWDC';\r\n$inspiretwdc-book-font: 'InspireTWDCBook';\r\n$inspiretwdc-light-font: 'InspireTWDCLight';\r\n$inspiretwdc-medium-font: 'InspireTWDCMedium';\r\n$inspiretwdc-heavy-font: 'InspireTWDCHeavy';\r\n$inspiretwdc-black-font: 'InspireTWDCBlack';\r\n$inspiretwdc-roman-font: 'InspireTWDCRoman';\r\n","// abstracts\r\n@import 'abstracts/variables';\r\n@import 'abstracts/functions';\r\n@import 'abstracts/mixins';\r\n@import 'base/global';\r\n@import 'base/reset';\r\n\r\n$common-border-gap: 32px;\r\n$desktop-content-width: 600px;","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n.resort-arrival-info {\r\n    .page-section {\r\n        @extend .clearfix;\r\n    }\r\n    padding: 30px 10px 0;\r\n\r\n    h3 {\r\n        @include font(16px, 28px);\r\n        color: $wdw-primary-text-color;\r\n        font-family: $inspiretwdc-heavy-font;\r\n        padding-left: 40px;\r\n        letter-spacing: -0.01px;\r\n        font-weight: 700;\r\n\r\n        _:default:not(:root:root),\r\n        &.safari_only {\r\n            font-family: $inspiretwdc-font;\r\n            font-weight: 700;\r\n        }\r\n    }\r\n\r\n    .left-section {\r\n        @extend .float-left;\r\n        width: 100%;\r\n\r\n        span {\r\n            position: absolute;\r\n            width: 30px;\r\n            height: 30px;\r\n            font-family: Peptasia-MessagingHelpSupport;\r\n            top: 0;\r\n            font-size: 21px;\r\n            color: $wdw-primary-text-color;\r\n            padding-top: 2px;\r\n        }\r\n\r\n        .input-container {\r\n            .single-select-box {\r\n                @include font(16px, 24px);\r\n                font-family: $inspiretwdc-roman-font;\r\n                height: 46px;\r\n                width: 100%;\r\n                float: left;\r\n                margin-left: 2px;\r\n                margin-bottom: 1px;\r\n                border-width: 0 0 2px;\r\n                z-index: 2;\r\n            }\r\n        }\r\n\r\n        .arrival-date {\r\n            @include font(12px, 16px);\r\n            color: $wdw-primary-text-color;\r\n            font-family: $inspiretwdc-heavy-font;\r\n            padding-left: 2px;\r\n            margin-top: 2px;\r\n        }\r\n\r\n        .resort-checkin-time {\r\n            @include font(14px, 21px);\r\n            clear: both;\r\n            color: $wdw-primary-text-color;\r\n            font-family: $inspiretwdc-medium-font;\r\n            padding-left: 4px;\r\n        }\r\n    }\r\n\r\n    .border-section {\r\n        margin-top: 30px;\r\n        height: 1px;\r\n        border-bottom: $primary-border;\r\n    }\r\n}\r\n\r\n.resort-arrival-mod-flow-ndme {\r\n    padding: 16px 0 0;\r\n    width: 100%;\r\n    clear: both;\r\n\r\n    &.expanded {\r\n        padding: 30px 0 0;\r\n    }\r\n\r\n    .page-section {\r\n        @extend .clearfix;\r\n    }\r\n\r\n    h3 {\r\n        @include font(16px, 28px);\r\n        color: $wdw-primary-text-color;\r\n        font-family: $inspiretwdc-heavy-font;\r\n        padding-left: 40px;\r\n        letter-spacing: -0.01px;\r\n        font-weight: 700;\r\n\r\n        _:default:not(:root:root),\r\n        &.safari_only {\r\n            font-family: $inspiretwdc-font;\r\n            font-weight: 700;\r\n        }\r\n    }\r\n\r\n    .left-section {\r\n        @include float-left;\r\n        width: calc(100% - 45px);\r\n\r\n        span {\r\n            position: absolute;\r\n            width: 30px;\r\n            height: 30px;\r\n            font-family: Peptasia-MessagingHelpSupport;\r\n            top: 0;\r\n            font-size: 21px;\r\n            color: $wdw-primary-text-color;\r\n            padding-top: 2px;\r\n        }\r\n    }\r\n\r\n    .right-section {\r\n        @include float-right;\r\n        text-align: right;\r\n        width: 45px;\r\n        margin-top: 2px;\r\n\r\n        .section-edit {\r\n            font-family: $inspiretwdc-medium-font;\r\n\r\n            @include font(12px, 24px, 500, 0);\r\n            color: #1B96D5;\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    .select-wrap {\r\n        margin-top: 3px;\r\n\r\n        .label-wrap {\r\n            .input-container {\r\n                .single-select-box {\r\n                    @include font(16px, 24px);\r\n                    font-family: $inspiretwdc-roman-font;\r\n                    height: 46px;\r\n                    width: 100%;\r\n                    float: left;\r\n                    margin-left: 2px;\r\n                    margin-bottom: 1px;\r\n                    border-width: 0 0 2px;\r\n                    z-index: 2;\r\n                }\r\n            }\r\n\r\n            .arrival-date {\r\n                @include font(12px, 16px);\r\n                color: $wdw-primary-text-color;\r\n                font-family: $inspiretwdc-heavy-font;\r\n            }\r\n\r\n            .resort-checkin-time {\r\n                clear: both;\r\n\r\n                @include font(14px, 21px);\r\n                color: $wdw-primary-text-color;\r\n                font-family: $inspiretwdc-medium-font;\r\n            }\r\n        }\r\n    }\r\n\r\n    .requested-wrap {\r\n        padding-left: 0;\r\n\r\n        .saved-arrival-time {\r\n            font-size: 12px;\r\n            color: $wdw-primary-text-color;\r\n            font-family: $inspiretwdc-book-font;\r\n            line-height: 20px;\r\n            letter-spacing: 0;\r\n        }\r\n    }\r\n\r\n    .border-section {\r\n        margin: 30px 0 0;\r\n        border-bottom: $primary-border;\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.resort-arrival-mod-flow-dme {\r\n    padding: 16px 0 0;\r\n    width: 100%;\r\n    clear: both;\r\n\r\n    .page-section {\r\n        @extend .clearfix;\r\n    }\r\n\r\n    h3 {\r\n        @include font(16px, 28px);\r\n        color: $wdw-primary-text-color;\r\n        font-family: $inspiretwdc-heavy-font;\r\n        padding-left: 40px;\r\n        margin-bottom: 3px;\r\n        letter-spacing: -0.01px;\r\n        font-weight: 700;\r\n\r\n        _:default:not(:root:root),\r\n        &.safari_only {\r\n            font-family: $inspiretwdc-font;\r\n            font-weight: 700;\r\n        }\r\n    }\r\n\r\n    .left-section {\r\n        @extend .float-left;\r\n        width: 100%;\r\n\r\n        span {\r\n            position: absolute;\r\n            width: 30px;\r\n            height: 30px;\r\n            font-family: Peptasia-MessagingHelpSupport;\r\n            top: 0;\r\n            font-size: 21px;\r\n            color: $wdw-primary-text-color;\r\n            padding-top: 2px;\r\n        }\r\n\r\n        .dme-reservation {\r\n            font-size: 12px;\r\n            font-family: $inspiretwdc-book-font;\r\n            color: $wdw-primary-text-color;\r\n        }\r\n    }\r\n\r\n    .border-section {\r\n        margin: 30px 0 0;\r\n        border-bottom: $primary-border;\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n/* For Desktop */\r\n@media (min-width: 767px) {\r\n    .resort-arrival-info {\r\n        padding: 30px 40px 0;\r\n\r\n        h3 {\r\n            padding-left: 40px;\r\n            letter-spacing: -0.01px;\r\n        }\r\n\r\n        .left-section {\r\n            width: calc(100% - 130px);\r\n            padding-right: 28px;\r\n\r\n            .input-container {\r\n                .single-select-box {\r\n                    margin-left: 40px;\r\n                    margin-bottom: 1px;\r\n                    width: 240px;\r\n                    z-index: 2;\r\n                }\r\n            }\r\n\r\n            span {\r\n                width: 30px;\r\n                height: 30px;\r\n                font-size: 24px;\r\n            }\r\n\r\n            .arrival-date {\r\n                padding-left: 40px;\r\n            }\r\n\r\n            .resort-checkin-time {\r\n                padding-left: 40px;\r\n            }\r\n\r\n            .resort-arrival-error-msg {\r\n                margin-left: 40px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .resort-arrival-mod-flow-ndme {\r\n        .left-section {\r\n            width: calc(100% - 130px);\r\n            padding-right: 28px;\r\n\r\n            span {\r\n                width: 30px;\r\n                height: 30px;\r\n                font-size: 24px;\r\n            }\r\n        }\r\n\r\n        .select-wrap {\r\n            padding-left: 40px;\r\n            margin-top: 15px;\r\n            width: calc(100% - 130px);\r\n            padding-right: 28px;\r\n\r\n            .label-wrap {\r\n                .input-container {\r\n                    .single-select-box {\r\n                        margin: 15px 0 8px 0;\r\n                        width: 334px;\r\n                        z-index: 2;\r\n                    }\r\n                }\r\n\r\n                .arrival-date {\r\n                    width: 100%;\r\n                }\r\n            }\r\n        }\r\n\r\n        .requested-wrap {\r\n            padding-left: 40px;\r\n            padding-right: 28px;\r\n            width: calc(100% - 130px);\r\n        }\r\n    }\r\n\r\n    .resort-arrival-mod-flow-dme {\r\n        .left-section {\r\n            width: calc(100% - 130px);\r\n            padding-right: 28px;\r\n\r\n            span {\r\n                width: 30px;\r\n                height: 30px;\r\n                font-size: 24px;\r\n            }\r\n\r\n            .dme-reservation {\r\n                padding-left: 40px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n    .resort-arrival-info {\r\n        padding: 30px 40px 0;\r\n\r\n        h3 {\r\n            padding-left: 40px;\r\n        }\r\n\r\n        .left-section {\r\n            .input-container {\r\n                .single-select-box {\r\n                    margin-left: 40px;\r\n                    margin-bottom: 1px;\r\n                    width: 240px;\r\n                    z-index: 2;\r\n                }\r\n            }\r\n\r\n            span {\r\n                width: 30px;\r\n                height: 30px;\r\n                font-size: 24px;\r\n            }\r\n\r\n            .arrival-date {\r\n                padding-left: 40px;\r\n            }\r\n\r\n            .resort-checkin-time {\r\n                padding-left: 40px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .resort-arrival-mod-flow-ndme {\r\n        .left-section {\r\n            span {\r\n                width: 30px;\r\n                height: 30px;\r\n                font-size: 24px;\r\n            }\r\n        }\r\n\r\n        .select-wrap {\r\n            margin-top: 3px;\r\n\r\n            .label-wrap {\r\n                .input-container {\r\n                    .single-select-box {\r\n                        margin: 15px 0 8px 0;\r\n                        width: 334px;\r\n                        z-index: 2;\r\n                    }\r\n                }\r\n\r\n                .arrival-date {\r\n                    width: 100%;\r\n                }\r\n            }\r\n        }\r\n\r\n        .requested-wrap {\r\n            padding-left: 40px;\r\n        }\r\n    }\r\n\r\n    .resort-arrival-mod-flow-dme {\r\n        .left-section {\r\n            span {\r\n                width: 30px;\r\n                height: 30px;\r\n                font-size: 24px;\r\n            }\r\n\r\n            .dme-reservation {\r\n                padding-left: 40px;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
